import React, { useState } from "react";
import KidsImage from "../assets/course-details/kids.png";
import Button from "./common/Button";
import Toast from "./common/Toast";
import { Heart } from "./Icons";

const CTASection = ({
  title,
  textSize,
  subText,
  btnText,
  btnSize,
  isAddToCartVisible,
  onBuyNowClick,
  onSecondaryClick,
  secondaryBtnText = "Add to Wishlist",
  secondaryIcon: SecondaryIcon = Heart,
  secondaryDisabled = false,
}) => {
  const [toast, setToast] = useState({
    show: false,
    title: "",
    message: "",
  });

  const handleBuyNow = () => {
    if (onBuyNowClick) {
      onBuyNowClick();
      return;
    }
    setToast({
      show: true,
      title: "Login required",
      message: "Create an account or login to buy the course",
    });
  };

  const handleSecondary = () => {
    if (onSecondaryClick) {
      onSecondaryClick();
      return;
    }
    setToast({
      show: true,
      title: "Login required",
      message: "Create an account or login to wishlist the course",
    });
  };

  return (
    <>
      <div className="mx-auto max-w-[1606px] px-4 sm:px-0">
        <div className="flex flex-col overflow-hidden rounded-lg bg-[#880A73] lg:flex-row lg:items-stretch lg:justify-between">
          <div className="flex max-w-full flex-col justify-center px-6 py-8 text-white sm:px-10 sm:py-10 lg:max-w-[1030px] lg:py-[55px] lg:pl-[67px] lg:pr-6">
            <h2
              className={`${textSize} font-bold leading-tight sm:leading-[56px]`}
            >
              {title}
            </h2>

            <p className="mt-[14px] text-base leading-[21px] sm:text-lg">
              {subText}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:mt-11 sm:gap-[11px] xl:flex-row xl:items-center [&>div]:w-full xl:[&>div]:w-auto xl:[&>div]:shrink-0">
              <Button
                btnText={btnText}
                onClick={handleBuyNow}
                btnClassName={`whitespace-nowrap bg-[#FF6636] py-4 leading-[19px] sm:py-[18.5px] w-full xl:w-auto ${btnSize} font-medium text-white`}
              />
              {isAddToCartVisible && (
                <Button
                  icon={SecondaryIcon}
                  btnText={secondaryBtnText}
                  onClick={handleSecondary}
                  disabled={secondaryDisabled}
                  btnClassName={
                    "h-full w-full whitespace-nowrap gap-4 bg-white px-6 py-[17px] text-sm font-bold text-black xl:w-auto sm:gap-6 sm:px-[57px]" +
                    (secondaryDisabled ? " cursor-not-allowed opacity-60" : "")
                  }
                />
              )}
            </div>
          </div>

          <div className="flex shrink-0 items-end justify-center px-6 pb-6 lg:justify-end lg:px-0 lg:pb-0 lg:pr-12">
            <img
              src={KidsImage}
              alt="kids learning"
              className="h-auto w-full max-w-[280px] object-contain object-bottom drop-shadow-[0_0_35px_rgba(255,255,255,0.75)] sm:max-w-[360px] lg:max-h-[320px] lg:w-auto lg:max-w-[469px]"
            />
          </div>
        </div>
      </div>
      {toast.show && (
        <Toast
          title={toast.title}
          message={toast.message}
          onClose={() => setToast((prev) => ({ ...prev, show: false }))}
        />
      )}
    </>
  );
};

export default CTASection;
